import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Brands } from "app/_models/brands";
import { ToastrService } from "ngx-toastr";
import { CrudBrandService } from "app/_services/MasterCrudOps/crud-brand.service";
declare const swal: any;

@Component({
  selector: "app-edit-brand",
  templateUrl: "./edit-brand.component.html",
})
export class EditBrandComponent implements OnInit {
  editBrandForm: FormGroup;
  editBrand: Brands;
  pageNumber: number;
  pageSize: number;

  constructor(
    private readonly fb: FormBuilder,
    private readonly toastr: ToastrService,
    private readonly crudBrandService: CrudBrandService,
    private readonly dialogRef: MatDialogRef<EditBrandComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.editBrand = JSON.parse(JSON.stringify(data.brand));
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
  }

  ngOnInit(): void {
    this.editBrandForm = this.fb.group({
      brandName: [
        this.editBrand.brandName ?? "",
        [Validators.required, Validators.maxLength(50)],
      ],
      description: [
        this.editBrand.description ?? "",
        [Validators.required, Validators.maxLength(100)],
      ],
    });
  }

  saveBrand() {
    const brandName = (this.editBrandForm.value.brandName ?? "").trim();
    const description = (this.editBrandForm.value.description ?? "").trim();
    let errorMessage = "";

    if (!brandName) {
      errorMessage += "Product Name is required.\n";
    }
    if (brandName.length > 50) {
      errorMessage += "Brand Name cannot be more than 50 characters.\n";
    }
    if (!description) {
      errorMessage += "Description is required.\n";
    }
    if (description.length > 100) {
      errorMessage += "Description cannot be more than 100 characters.\n";
    }

    if (errorMessage) {
      swal({
        title: "",
        text: errorMessage,
        type: "error",
        confirmButtonClass: "btn btn-info",
      });
      return;
    }

    swal({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-success",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "YES, Update IT!",
    }).then((result) => {
      if (result === true) {
        let model = {
          brandId: this.editBrand.brandId,
          brandName: brandName,
          description: description,
        };
        this.updateBrand(model);
      } else {
        this.toastr.info("result not saved");
      }
    });
  }

  updateBrand(model: any) {
    this.crudBrandService.updateBrand(model).subscribe(
      (data) => {
        if (data.didError) {
          swal({
            title: "",
            text: data.message,
            type: "error",
            confirmButtonClass: "btn btn-info",
          });
        } else {
          this.dialogRef.close(true);
          swal({
            title: "",
            text: data.message,
            type: "success",
            confirmButtonClass: "btn btn-info",
          });
          let result = {
            status: true,
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
          };
          this.dialogRef.close(result);
        }
      },
      (error) => {
        let errorMessage =
          error.error?.title ??
          error.error ??
          "Something went wrong. Please contact admin.";

        // Check if it's a validation error response with the `errors` object
        if (error.error?.errors) {
          const allErrors = Object.values(error.error.errors).flat(); // Flatten all error arrays
          if (allErrors.length > 0) {
            errorMessage = allErrors[0]; // Use the first validation message
          }
        } else if (typeof error.error === "string") {
          errorMessage = error.error;
        } else if (error.error?.title) {
          errorMessage = error.error.title;
        }
        swal({
          title: "",
          text: errorMessage,
          type: "error",
          confirmButtonClass: "btn btn-info",
        });
      }
    );
  }

  close() {
    let result = {
      status: false,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
    };
    this.dialogRef.close(result);
  }
}
